import { useState } from 'react';
import { Autocomplete, TextField } from "@mui/material";
import uuidv4 from 'src/utils/uuidv4';
import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';
import { useStyles } from 'src/careflow/helpers/workflowStyle';

const SelectComponent = (props: any) => {

  const classes: any = useStyles({});
  const currentUser = useAuth().getCurrentUser();

  const {
    record,
    checklistItem,
    handler,
    data
  } = props?.others;

  const items = 
    data &&
    data.length > 0 ? 
    [
      ...data
        .filter((i: any) => i?.userName === currentUser?.userName)
        .map((i: any) => ({
          label: `${i?.firstName} ${i?.lastName} (Me)`,
          id: i?.userName
        })),
      ...data
        .filter((i: any) => i?.userName !== currentUser?.userName)
        .map((i: any) => ({
          label: `${i?.firstName} ${i?.lastName}`,
          id: i?.userName
        }))
    ] : [{ label: '', id: '' }];

  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');

  const metadata = checklistItem && checklistItem?.metadata ? JSON.parse(checklistItem?.metadata) : {};
  const { className = null } = metadata?.ui || {};
  const safeClassName = className && classes && classes[className] ? classes[className] : undefined;

  return (
    <div  style={{ marginBottom: 10 }}> 
      <Autocomplete
        disablePortal={false}
        id="combo-box-demo"
        value={value}
        inputValue={inputValue}
        className={safeClassName}
        onInputChange={(event: any, newInputValue: any) => {
          setInputValue(newInputValue);
        }}
        options={items}
        renderInput={(params) => (
          <TextField 
            {...params} 
            fullWidth 
            label={`${props?.name || props?.elementName || ""} ${checklistItem?.isRequired ? "*" : ""}`.trim()}
          />
        )}
        renderOption={(props: any, option: any) => (
          <li {...props} key={uuidv4()}>
            {option?.label}
          </li>
        )}
        onChange={(event: any, username: any | null) => {
          if(!username) return;
          setValue(username);
          handler({
            record,
            checklistItem,
            more: { selectedUser: username?.id },
          })
        }}
      />
    </div>
  );
};

export default SelectComponent;
